import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import { gql } from '@nerdwallet/apollo';
import { VALUE_SIZES } from '@nerdwallet/marketplace/constants/drivers';
import ContentSanitizer from '../../content-sanitizer';

/**
 * Check against type 'string' to match the underlying
 * html-react-parser lib. Additionally, this ensures we render both
 * single React elements as well as arrays of React elements.
 * Additional param propertyThatUsesHttp used to override anchor element in content-sanitizer
 * @see {@link https://github.com/remarkablemark/html-react-parser/blob/master/index.js#L16}
 */
export var sanitizeNode = function sanitizeNode(node) {
  var respectUnsafeHref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return typeof node !== 'string' ? node : /*#__PURE__*/React.createElement(ContentSanitizer, {
    html: node,
    respectUnsafeHref: respectUnsafeHref
  });
};

/**
 * Interface for quick fact configuration.
 * @todo - This should come from `@nerdwallet/react-quick-facts`.
 */

// A renderer that accepts children to be compatible but always returns null
export var defaultRenderer = function defaultRenderer(_ref) {
  var children = _ref.children;
  return !children ? null : null && /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

/**
 * Translate GraphQL sponsored drivers into the interface expected by `<QuickFacts />`.
 */
export var normalizeEntityPlacementDriver = function normalizeEntityPlacementDriver(placementDriver) {
  var driverRenderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultRenderer;
  var DriverRenderer = driverRenderer;
  var valueTooltip;
  if (placementDriver.valueTooltip && placementDriver.valueTooltipHasHtml) {
    // Can't use sanitizeNode here because of Mortgages use of `table`
    /* eslint-disable react/no-danger */
    valueTooltip = /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: placementDriver.valueTooltip
      }
    });
    /* eslint-enable react/no-danger */
  } else {
    valueTooltip = placementDriver.valueTooltip;
  }
  return {
    description: /*#__PURE__*/React.createElement(DriverRenderer, null, placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.description),
    id: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.label,
    label: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.label,
    labelTooltip: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.labelTooltip,
    valueTooltip: valueTooltip,
    value: /*#__PURE__*/React.createElement(DriverRenderer, null, placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.value),
    /** @todo - Should we standardize driver size? */
    valueSize: VALUE_SIZES.MEDIUM
  };
};
normalizeEntityPlacementDriver.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment normalizeEntityPlacementDriver on EntityPlacementDriver {\n    __typename\n    description\n    label\n    labelTooltip\n    value\n    valueTooltip\n    valueTooltipHasHtml\n  }\n"])));